import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';
import techConfig from '../../../techConfig';
import * as Constant from '../../../constants/actionTypes';

const PrivateRoute = ({ component: Component, isAuthenticated, path, user, ...rest }) => {
  const { MemberID } = { ...user };
  const { messagesAdmin, adminMemberID } = techConfig;
  return (
    <Route
      {...rest}
      path={path}
      render={props => {
        const { location } = props;
        if (
          isAuthenticated ||
          (path === `${messagesAdmin}` && isAuthenticated && MemberID === `${adminMemberID}`)
        ) {
          return <Component {...props} />;
        }
        return (
          <Redirect
            to={{
              pathname: Constant.SLASH,
              state: { from: location },
            }}
          />
        );
      }}
    />
  );
};

PrivateRoute.propTypes = {
  component: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  path: PropTypes.string.isRequired,
  user: PropTypes.object,
  location: PropTypes.object,
};

PrivateRoute.defaultProps = {
  user: {},
  location: {},
};

export default memo(PrivateRoute);
